module.exports = __webpack_public_path__ + "static/media/friozem_interno.fb9cf6ad.png";